import { createStore } from "vuex";

class DialogMessage {
    constructor(type, title, message, defaultValue, resolve, confirmText, cancelText) {
        this.id = Date.now() + Math.random().toString(36).substring(7);
        this.type = type; // 'alert', 'confirm', 'prompt'
        this.title = title || '';
        this.message = message || '';
        this.defaultValue = defaultValue || '';
        this.resolve = resolve;
        this.confirmText = confirmText || '';
        this.cancelText = cancelText || '';
    }
}

const store = createStore({
    state: {
        dialogs: []
    },
    mutations: {
        ADD(state, dialog) {
            state.dialogs.push(dialog);
        },
        REMOVE(state, id) {
            state.dialogs = state.dialogs.filter(d => d.id !== id);
        }
    },
    actions: {
        alert(context, options) {
            return new Promise((resolve) => {
                const title = typeof options === 'string' ? '' : (options.title || '');
                const message = typeof options === 'string' ? options : options.message;
                const confirmText = typeof options === 'object' ? (options.confirmText || '') : '';
                const dialog = new DialogMessage('alert', title, message, '', resolve, confirmText, '');
                context.commit("ADD", dialog);
            });
        },
        confirm(context, options) {
            return new Promise((resolve) => {
                const title = typeof options === 'string' ? '' : (options.title || '');
                const message = typeof options === 'string' ? options : options.message;
                const confirmText = typeof options === 'object' ? (options.confirmText || '') : '';
                const cancelText = typeof options === 'object' ? (options.cancelText || '') : '';
                const dialog = new DialogMessage('confirm', title, message, '', resolve, confirmText, cancelText);
                context.commit("ADD", dialog);
            });
        },
        prompt(context, options) {
            return new Promise((resolve) => {
                const title = typeof options === 'string' ? '' : (options.title || '');
                const message = typeof options === 'string' ? options : options.message;
                const defaultValue = options.defaultValue || '';
                const confirmText = typeof options === 'object' ? (options.confirmText || '') : '';
                const cancelText = typeof options === 'object' ? (options.cancelText || '') : '';
                const dialog = new DialogMessage('prompt', title, message, defaultValue, resolve, confirmText, cancelText);
                context.commit("ADD", dialog);
            });
        },
        resolveDialog(context, { id, result }) {
            const dialog = context.state.dialogs.find(d => d.id === id);
            if (dialog) {
                dialog.resolve(result);
                context.commit("REMOVE", id);
            }
        }
    }
});

export default store;
